module.exports = __webpack_public_path__ + "static/media/mode-3.b19f3578.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-3.svg
// module id = 976
// module chunks = 2